import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Grid } from '@mui/material';
import MoreDetailsDriver from 'pages/vendor/driverVendor/MoreDetailsDriver';
import { vendorVechileTableData } from 'pages/vendor/vendorTable/TableData';
import CommonTable from 'components/commonTable/CommonTable';
import FilterSubVendor from './FilterSubVendor';
import CommonFilter from 'components/commonFilter/CommonFilter';
import SearchBar from 'components/commonSearch/SearchBar';
import Loader from 'components/loader/Loader';

function TabSubVendor({ onTabChange, tableData, onClickTable, value, onClickMoreIcon, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage, onFilterChange, onRestFilter, filterdata, subVendorMoreDetails, subVendorLocation,onSearch,defaultStatus,chooseYourServiceData,loaderDriver,loaderVehicle, loaderSubVendorMoreData,loaderSubVendorServiceArea,loaderSubVendorService}) {
  const handleChange = (event, newValue) => {
    onTabChange(newValue);
  };

  const onClickTableVendor = (val) => {
    onClickTable(val);
  };

  return (
    <Grid container>
      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item xs={6} sm={6}>
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }, // Replace 'none' with your desired color
                  }}
                >
                  <Tab label="Driver" value="1" className="tabStyle" />
                  <Tab label="Vehicle" value="2" className="tabStyle" />
                  <Tab label="More Details" value="3" className="tabStyle" />
                </TabList>
              </Grid>
              {value !== '3' && 
              <Grid item
                container
                xs={6} sm={6}   
                spacing={1}
                direction='row'
                justifyContent='flex-end'
                alignItems='center'>
                <Grid item>
                  {value !== '3' && <SearchBar  onSearch={onSearch}/>}
                </Grid>
                <Grid item> <CommonFilter defaultStatus={defaultStatus} filterdata={filterdata} onFilterChange={onFilterChange}
                  onRestFilter={onRestFilter} />
                </Grid>
              </Grid>}

            </Grid>
            <TabPanel
              value="1"
              sx={{ width: '100%' }}
              className="tabPanelStyle"
            >
              {loaderDriver? <Loader/> :( 
              <CommonTable
                data={tableData}
                onClickTableVendor={onClickTableVendor}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                onClickMoreIcon={onClickMoreIcon}
                isClickable = {true}
              />)}
            </TabPanel>
            <TabPanel value="2" className="tabPanelStyle">
            {loaderVehicle? <Loader/> :( 
              <CommonTable
                data={tableData}
                onClickTableVendor={onClickTableVendor}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                page={page}
                rowsPerPage={rowsPerPage}
                onClickMoreIcon={onClickMoreIcon}
                tabName={'vehicle'}
                isClickable = {true}
              />)}
            </TabPanel>
            <TabPanel value="3" className="tabPanelStyle">
            {loaderSubVendorMoreData ? <Loader/> : (
              <MoreDetailsDriver subVendorMoreDetails={subVendorMoreDetails} subVendorLocation={subVendorLocation} chooseYourServiceData={chooseYourServiceData} />)}
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default TabSubVendor;
